import { render, staticRenderFns } from "./BookshelfEdit.vue?vue&type=template&id=b2740e58&scoped=true&"
import script from "./BookshelfEdit.vue?vue&type=script&lang=ts&"
export * from "./BookshelfEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2740e58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
